export const columns = [
  {
    name: 'id',
    label: '',
    hidden: true,
  },
  {
    name: 'createdAt',
    label: 'Date',
  },
  {
    name: 'currencyId',
    label: 'Currency',
  },
  {
    name: 'sum',
    label: 'Amount',
  },
  {
    name: 'creditSum',
    label: 'Credit account',
  },
  {
    name: 'debitSum',
    label: 'Debit Account',
  },
];

export const columnsLabels = {};

export const schema = {};

export const defaultSorter = {};
